<template>
  <div class="greetingsandphrasess-view">
    <div class="column column-left"></div>
      <div class="column column-center"> 
        <h1 id="title">12 Common Japanese Greetings And Phrases</h1>
        <span>Best Japanese phrases that natives use every day</span>
        <div id="intro">
          When starting your Japanese language journey it is hard to know where to start.
          You could start with the Alphabet or the numbers, but its our opinion that starting with 
          some basic greetings and phrases is best. 
        </div>
        <div class="greetingsandphrases-container">
          <h3>1. こんにちわ - Konichiwa</h3> 
          <span>Simple greeting meaning hello or good day</span>
          <p class="greetingsandphrases-main-text">
              Most of you are going to know this one. こんにちわ is the Japanese term used for greeting people. You can
              use this in many situations. 

              Good scenarios to use this term is meeting someone for the first time, greeting someone in passing, or even saying good 
              day to someone. Kind of a catch all term.
          </p>
          <p>
            Something that may happend in Japan is peolpe will wave to you on a train or boat and say "konnichiwa"
            as they pass by.
          </p>
        </div>
        <div class="greetingsandphrases-container">
          <h3>2. お早う - Ohaio</h3> 
          <span>Good Morning</span>
          <p class="greetingsandphrases-main-text">
              This term translates to "good morning". If you are ever in a hotel lobby in the morning 
              the staff will often say "ohaio gozaimasu" which is a more formal way of saying good morning. 
              However, most people like co-workers or friends will say "Ohaio" or "haizaimaasu" which is a
              shortend version of the formal saying. Using "ohaio gozaimasu" with friends or family usually
              feels far too formal. Almost like saying "I bid you good morning, madam / sir" it just feels 
              wrong in those casual interactions. So to impress your Japanese friends say "haizaimaasu" quickly.
          </p>
        </div>
        <div class="greetingsandphrases-container">
          <h3>3. そう - Sou</h3> 
          <span>General Term Of Agreement</span>
          <p class="greetingsandphrases-main-text">
            The <em>most</em> common thing you will hear in Japanese. Sou is used all. The. Time.
            Part of Japanese culture is being agreeable, you don't want to step on people's toes. 
            Sou is often used to do this. When someone is talking about how good something is a common
            reply is "sou sou sou" said quickly. This lets the person know you agree with them.
            "sou desu ne" and "sou ne" are also used frequently. The agreeability communicated with "ne" is heightened and the
            "desu" makes it more formal. If someone says someting you don't understand you can say "sou" to get by. 
          </p>
        </div>
        <div class="greetingsandphrases-container">
          <h3>4. お願いします - Oneigai Shimasu</h3> 
          <span>Pleasent Way Of Requesting</span>
          <p class="greetingsandphrases-main-text">
            When you are at an izakaiya you may want to order some more beer or food.
            How do you go about doing that? Simpily point to something on the menu and say "Oneigai Shimasu".
            This means "can I please have one of these". This can also be used to confirm a question. 
            Someone may want to confirm a service or item, saying "Oneigai Shimasu" will do this.
          </p>
        </div>
        <div class="greetingsandphrases-container">
          <h3>5. すみません - Sumimasen</h3> 
          <span>Excuse Me / Sorry</span>
          <p class="greetingsandphrases-main-text">
           Another common term you will hear and use.
           Sumimasen is used in any situation where a inconveience happened. 
           Bump into someone? You should say "sumimasen". Spill your drink?
           Say "sumimasen". Want to get someone's attention. "Sumimasen".
           When at a restraunt and want to order? Raise your hand and exclaim "sumimasen!".
           This is a very useful term and will get far in your travels across the country.
          </p>
        </div>
        <div class="greetingsandphrases-container">
          <h3>6. じゃあ、またね - Jyaa, Matane</h3> 
          <span>See You Later</span>
          <p class="greetingsandphrases-main-text">
            Many believe that the Japanese phrase for "goodbye" is sayonara. This is true however that goodbye 
            is used when you're not going to see someone for a long periods of time. It feels kind of final 
            saying sayonara. Jyaa, matane is more a kin to "see you later" and is used casually among friends and 
            family. 
          </p>
        </div>
        <div class="greetingsandphrases-container">
          <h3>7. とんでも無い - Tondemonai </h3> 
          <span>Not at all</span>
          <p class="greetingsandphrases-main-text">
            Lesser known Japanese phrase meaning something like "not at all" depending on the context.
            Use this phrase when someone is thanking you for something and you want to say that it's not 
            a big deal. For example let's say you are giving up your chair for an elderly person and say 
            "arigatou" you can say "tondemonai" back. Many locals will be impressed with this one. 
          </p>
        </div>
        <div class="greetingsandphrases-container">
          <h3>8. どう致しまして - Douitashimashite </h3> 
          <span>You're Welcome</span>
          <p class="greetingsandphrases-main-text">
            Similiar to tondemonai this term means your welcome or not at all. It is a more formal way of 
            replying to a thank you frome someone. It is used less in everyday speech than tondemonai but you
            will hear this phrase quite often. When in a formal setting it is best to use this expression to be 
            safe. 
          </p>
        </div>
        <div class="greetingsandphrases-container">
          <h3>9. おやすみ - Oyasumi </h3> 
          <span>Good Night</span>
          <p class="greetingsandphrases-main-text">
            Oyasumi is the general term for good night. It comes from the more formal oyasumi nasai which means 
            "you should get some sleep" in english we would probably say "get some shut eye". Despite the 
            direct translation of the word this term is used when going to bed or leaving to go home at night.
          </p>
        </div>
        <div class="greetingsandphrases-container">
          <h3>10. 久し振り - Hisashiburi </h3> 
          <span>Long Time No See</span>
          <p class="greetingsandphrases-main-text">
           If you haven't seen someone in a long time hit them with "hisashiburi desu ne" which means "it's been a long time hasn't it".
           This term can also be used to refer to an action like "hisashiburi ni kore o tabemashita" meaning "haven't eaten this in a while". 
           So whenever you are reuniting with something or someone use "hisashiburi".
          </p>
        </div>
        <div class="greetingsandphrases-container">
          <h3>11. 初めまして - Hajimemashite </h3> 
          <span>Nice to meet you (Specifically For The First Time)</span>
          <p class="greetingsandphrases-main-text">
           Going to Japan you will meet many new people for the first time. To greet these new 
           friends you should say "hajimemashite". Saying this term will communicate that it is a pleasure 
           meeting for the first. Many people will say this to you aswell so make sure to say it back. 
           After saying this term there is another term you can often use.
          </p>
        </div>
        <div class="greetingsandphrases-container">
          <h3>12. 宜しく お願いします - Yorushiku Oneigaisihmasu </h3> 
          <span></span>
          <p class="greetingsandphrases-main-text">
           Combining "yorushiku" and "oneigaisihmasu" you can end an introduction starting with "hajimemashite".
           Saying "hajimemashite &lt;your name&gt; degozaimasu yorushiku oneigaisihmasu" 
           means "nice to meet you im &lt;your name&gt; I look forward to working with you".
           This is a common introduction format but is usually used in formal contexts.
          </p>
        </div>
        <div id="conclusion">Hopefully these greetings and phrases will help you in your journey across Japan!</div>
      </div>
    <div class="column column-right">
    </div>
  </div>
</template>

<script>

export default {
  name: "GreetingsAndPhrasess",
  components: {
    
  },
  data() {
    return {
    };
  },
  methods: {

  },
};
</script>

<style scoped>

#conclusion {
  margin-top: 50px;
  margin-bottom: 100px;
}

.greetingsandphrases-main-text {
  margin-top: 30px;
}

.greetingsandphrases-container {
  margin-top: 30px;
}

#title {
  margin-top: 50px;
}

#intro {
  margin-top: 30px;
}

.greetingsandphrasess-view {
  text-align: left;
  font-family: Arial, sans-serif;
  display: flex;
  width: 100%;
}

/* Specific column widths */
.column-left {
  width: 15%; /* Left column occupies 20% */
  /* background-greetingsandphrases:  #000080; */
}

.column-center {
  width: 70%; /* Center column occupies 60% */
  padding: 0 50px 0px 50px
}

.column-right {
  width: 15%; /* Right column occupies 20% */
  /* background-greetingsandphrases:  #000080; */
}

</style>
